import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://fcnttxkvafinakxekgdr.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZjbnR0eGt2YWZpbmFreGVrZ2RyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODI5NDEwODEsImV4cCI6MTk5ODUxNzA4MX0.EIRkSjC9uvN-G6mB-WubM4lvcGu5ftpIMx5yDWm_ieE";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
